import React, { PropsWithChildren } from 'react';
import { Icon } from '../Icon';

type Props = PropsWithChildren<{
  onChangeFiles: (files: File[]) => void;
  multiple?: boolean;
  accept?: string;
  maxLength?: number;
  disabled?: boolean;
  className?: string;
  /** テストから隠しinputを参照するためのid。 */
  inputTestId?: string;
}>;

export function InputFile({
  children,
  onChangeFiles,
  multiple = false,
  accept,
  maxLength,
  disabled = false,
  className = '',
  inputTestId,
}: Props) {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const onChange = () => {
    if (fileInputRef.current) {
      const files = fileInputRef.current?.files;
      if (files && files.length) {
        onChangeFiles(Array.from(files));
      }
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        data-testid={inputTestId}
        onChange={onChange}
        accept={accept}
        multiple={multiple}
        maxLength={maxLength}
      />
      <button
        onClick={() => {
          if (!disabled) {
            fileInputRef?.current?.click();
          }
        }}
        className={`${disabled ? 'opacity-50' : ''} ${className}`}
        disabled={disabled}
      >
        {children || <Icon icon={'image'} />}
      </button>
    </>
  );
}
